export default class BlockPartners {
  constructor(el) {
    this.el = el

    this.x = 0

    this.wrapper = el.querySelector('.js-partners-wrapper')
    this.list = el.querySelector('.js-partners-list')
    this.buttons = el.querySelectorAll('.js-partners-button')

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const wrapperBox = this.wrapper.getBoundingClientRect()
        const listBox = this.list.getBoundingClientRect()
        const mini = wrapperBox.width - listBox.width
        
        if (this.x !== mini) {
          this.x -= wrapperBox.width * .9
          this.x = Math.max(this.x, mini)
        } else {
          this.x = 0
        }
        
        this.list.style.transform = `translate3d(${this.x}px, 0, 0)`
      })
    })
  }
}
